import { render } from "./notifications.vue?vue&type=template&id=6761fb00&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6761fb00"

export default script